module.exports = __webpack_public_path__ + "img/postman_visiteur_update.203d272a.png";